module.exports = __webpack_public_path__ + "img/hc_pro_three_6.6e0afa91.jpg";